import { useI18n } from 'vue-i18n';
import { useCommonStore } from '@/stores/common';

export const useTurnstileAlert = () => {
  const { t } = useI18n({ useScope: 'global' });
  const commonStore = useCommonStore();

  const showTurnstileErrorAlert = (): void => {
    commonStore.setAlert({
      open: true,
      type: 'error',
      title: t('security.turnstileFailedTitle'),
      description: t('security.turnstileFailedDescription'),
    });
  };

  return {
    showTurnstileErrorAlert,
  };
};
